import { render, staticRenderFns } from "./LessonTableEntry.vue?vue&type=template&id=2c0b1a48"
import script from "./LessonTableEntry.vue?vue&type=script&lang=js"
export * from "./LessonTableEntry.vue?vue&type=script&lang=js"
import style0 from "./LessonTableEntry.vue?vue&type=style&index=0&id=2c0b1a48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports